import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import React, { FC } from "react";
import { COLOR_GREY_12, COLOR_GREY_11 } from "shared/theme/colors";
import UnreadTicketMessages from "../TicketsList/Ticket/components/UnreadTicketMessages";
import { StyledAvatarContainer, StyledText } from "./styled";

type Props = {
  userName: string;
  userId: string;
  isHiddenUserName?: boolean;
  bgColor: string;
  unreadMessagesCount?: number;
};

const UserInfo: FC<Props> = ({
  userName,
  userId,
  isHiddenUserName,
  bgColor,
  unreadMessagesCount,
}) => {
  const nameParts = userName?.split(" ");
  const name = nameParts?.[0]?.charAt(0) || "";
  const surname = nameParts?.[1]?.charAt(0) || "";

  return (
    <Box
      display="flex"
      columnGap="0.75rem"
      ml={isHiddenUserName ? 0 : 5}
      position="relative"
    >
      <Box
        display="flex"
        columnGap="0.5rem"
        alignItems={isHiddenUserName ? "flex-start" : "center"}
      >
        <UnreadTicketMessages unreadMessagesCount={unreadMessagesCount ?? 0} />
        <StyledAvatarContainer bgColor={bgColor}>
          <Typography variant="bodyMSemiBold" textTransform="uppercase">
            {name}
            {surname}
          </Typography>
        </StyledAvatarContainer>
      </Box>
      {!isHiddenUserName && (
        <Box display="flex" flexDirection="column">
          <StyledText
            variant="bodyMSemiBold"
            textTransform="uppercase"
            color={COLOR_GREY_12}
          >
            {userName ?? ""}
          </StyledText>
          <StyledText variant="bodyMRegular" color={COLOR_GREY_11}>
            ID: {userId}
          </StyledText>
        </Box>
      )}
    </Box>
  );
};

export default UserInfo;
